import * as React from 'react';
import { SVGProps } from 'react';

const IconLentaStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 6v3h1V7h2V6H5ZM7 10v1h3V8H9v2H7Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 13a2 2 0 0 1-2-2V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h13v-2Zm-3.465 0H3V4h9v7c0 .729.195 1.412.535 2Z"
    />
  </svg>
);
export default IconLentaStrokedSizeS;
